import { ICommand } from 'core-ts-types';
import { CustomTextModel, CustomTextService } from 'data-ng-custom-text';
import * as _4 from 'lodash4';
import { StudyGroupModalService } from '../../modals/study_groups_modal_service';
import { StudyGroupMembersQuery } from '../../queries/study_group_members_query';
import { ICourseSection, IStudyGroupMember } from '../../study_group_interfaces';

export class StudyGroupBuddiesController {
  private section: ICourseSection;
  private filteredBuddies: IStudyGroupMember[];
  private searchStudent: string;
  private isShowingResults: boolean = true;
  private isShowingAllBuddies: boolean = true;
  private shouldAutoFocus: boolean = false;
  private enableSelection: boolean = false;
  private updateSearchStudent: () => void;
  private customIntro: string = 'Get in touch with other students you would like to form a study group with.';
  private canSelectAll: boolean = true;

  constructor(
    private ngStudyGroupModalService: StudyGroupModalService,
    private $state: ng.ui.IStateService,
    private accountModel: any,
    private deleteUserFromStudyGroupCommand: ICommand,
    private selectUserCommand: ICommand,
    private clearAllSelectedUsersCommand: ICommand,
    private selectAllUsersCommand: ICommand,
    private ngStudyGroupMembersQuery: StudyGroupMembersQuery,
    private ngCustomTextService: CustomTextService,
    private ngCustomTextModel: CustomTextModel
  ) {}

  $onInit(): void {
    this.filteredBuddies = this.ngStudyGroupMembersQuery.result.buddies;
    this.updateSearchStudent = this.filterBuddies.bind(this);
    this.getCustomIntro();
  }

  getCustomIntro() {
    if (_4.isEmpty(this.ngCustomTextModel.read())) {
      this.ngCustomTextService.loadCustomText().then(() => {
        this.setCustomIntro();
      });
    } else {
      this.setCustomIntro();
    }
  }

  setCustomIntro() {
    this.customIntro =
      _4.get(_4.find(this.ngCustomTextModel.read(), { nk: 'STUDY_BUDDY_INSTR_GROUP_INTRO' }), 'text') ||
      this.customIntro;
  }

  selectBuddy(buddy: any) {
    this.selectUserCommand(buddy.id);
    this.canSelectAll =
      !this.ngStudyGroupMembersQuery.result.isAllUsersSelected && !this.isAllFilteredBuddiesSelected();
  }

  selectFilteredBuddies() {
    _4.filter(this.filteredBuddies, (buddy: any) => !buddy._isChecked).forEach((member: IStudyGroupMember) => {
      return this.selectBuddy(member);
    });
  }

  selectAll() {
    this.canSelectAll = false;
    if (this.isShowingAllBuddies) {
      return this.selectAllUsersCommand();
    } else {
      return this.selectFilteredBuddies();
    }
  }

  isAllFilteredBuddiesSelected() {
    return this.filteredBuddies.every((buddy) =>
      _4.includes(this.ngStudyGroupMembersQuery.result.selectedBuddies, buddy)
    );
  }

  filterBuddies(value: string) {
    this.searchStudent = value;
    this.filteredBuddies = _4.filter(this.ngStudyGroupMembersQuery.result.buddies, (buddy: IStudyGroupMember) =>
      _4.includes(_4.toLower(buddy.name), _4.toLower(this.searchStudent))
    );
    this.isShowingResults = this.filteredBuddies.length > 0;
    this.isShowingAllBuddies = this.filteredBuddies.length === this.ngStudyGroupMembersQuery.result.buddiesCount;
    this.canSelectAll =
      !this.ngStudyGroupMembersQuery.result.isAllUsersSelected && !this.isAllFilteredBuddiesSelected();
  }

  clearSelection(): void {
    this.canSelectAll = true;
    this.clearAllSelectedUsersCommand();
  }

  changeSelection(): void {
    this.ngStudyGroupMembersQuery.result.isAllUsersSelected || this.isAllFilteredBuddiesSelected()
      ? this.clearSelection()
      : this.selectAll();
  }

  getselectionLabelText() {
    return this.canSelectAll ? 'Select All' : 'Clear All';
  }

  leaveStudyGroup(): void {
    this.ngStudyGroupModalService.showBusySpinner = true;
    this.deleteUserFromStudyGroupCommand(this.section.id).then(() => {
      this.ngStudyGroupModalService.showBusySpinner = false;
      this.ngStudyGroupModalService.hide();
      this.$state.go('my.studyGroups');
    });
  }

  confirmRemoving(): void {
    this.ngStudyGroupModalService.show({
      heading: 'Remove from Group?',
      prompt: 'Are you sure you want to remove yourself from the',
      className: ` ${this.section.courseTitle}-${this.section.cd} Study Buddies group?`,
      cancelButtonText: `Nevermind`,
      confirmButtonText: `Yes, Leave`,
      invertButtonStyles: true,
      confirmationCallBack: this.leaveStudyGroup.bind(this)
    });
  }
}

export class StudyGroupBuddiesComponent implements ng.IComponentOptions {
  public templateUrl: string = 'capability-ng-study-groups/src/components/study_group_buddies/study_group_buddies.html';
  public controller: any = StudyGroupBuddiesController;
  public controllerAs: string = '$ctrl';
  public bindings: any = {
    section: '<',
    enableSelection: '<'
  };
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-study-groups/src/components/study_group_buddies/study_group_buddies_component.ts